import { Button } from '@/components/form/Button';
import FieldLabel from '@/components/form/fields/FieldLabel';
import { TextInput } from '@/components/form/fields/text/TextInput';
import { useModal } from '@/components/modal/useModal';
import { FunctionComponent } from 'react';
import { ProcessedOrgTree } from '@/components/org/TenantRestrictionTree';
import CreateProductCustomerRestrictionsModal from './CreateProductCustomerRestrictionsModal';
import { useBuildRestrictionLabelFromOrgTree } from './useBuildRestrictionLabelFromOrgTree';

interface ProductCustomerRestrictionsProps {
  onConfirmCallback: (orgTree: ProcessedOrgTree[]) => Promise<void>;
  orgTree: ProcessedOrgTree[];
}

const CreateProductCustomerRestrictions: FunctionComponent<ProductCustomerRestrictionsProps> = ({
  onConfirmCallback,
  orgTree
}) => {
  const props = useModal<{
    orgTree: ProcessedOrgTree[];
    onConfirmCallback: (orgTree: ProcessedOrgTree[]) => Promise<void>;
  }>();

  const label = useBuildRestrictionLabelFromOrgTree(orgTree);

  return (
    <>
      <CreateProductCustomerRestrictionsModal {...props} />
      <div className="mb-0.5">
        <FieldLabel id={'restrictions'} label={'Customer Restrictions'} />
        <div className="flex space-x-4">
          <TextInput id={'restrictions'} value={label} readonly onChange={() => {}} />
          <Button
            onClick={() => {
              props.open({ orgTree, onConfirmCallback });
            }}
          >
            Edit
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateProductCustomerRestrictions;
